import FantasyPlayerDetailedStatsModel from "../FantasyPlayerDetailedStatsModel";
import FantasyPlayersPointsModel from "../FantasyPlayersPointsModel";
import PlayerDetailedPointsModel from "../PlayerDetailedPointsModel";
import PlayerDetailedStatsModel from "../PlayerDetailedStatsModel";
import PlayerPointsModel from "../PlayerPointsModel";
import PlayerStatsMatchModel from "../PlayerStatsMatchModel";

export default class FantasyRemapper {
  public remapPlayersPoints = (response: any) => {
    const model = new FantasyPlayersPointsModel();

    model.meta.filters.templateId = response.meta.filters.template_id;
    model.data = response.data.map((v) => this.remapPlayersPointsData(v));

    return model;
  };

  private remapPlayersPointsData = (response: any) => {
    const model = new PlayerPointsModel();

    model.playerId = response.player_id;
    model.points = response.points;
    model.rank = response.rank;

    return model;
  };

  public remapPlayerDetailedStats = (response: any) => {
    const model = new FantasyPlayerDetailedStatsModel();

    model.meta.filters.templateId = response.meta.filters.template_id;
    model.meta.filters.playerId = response.meta.filters.player_id;
    model.data = response.data.map((v) => this.remapPlayerDetailedData(v));

    return model;
  };

  private remapPlayerDetailedData = (response: any) => {
    const model = new PlayerDetailedStatsModel();

    model.matchId = response.match_id;
    model.points = response.points
      ? this.remapPlayerDetailedPoints(response.points)
      : null;
    model.stats = response.stats
      ? this.remapPlayerDetailedStatsData(response.stats)
      : null;

    return model;
  };

  private remapPlayerDetailedPoints = (response: any) => {
    const model = new PlayerDetailedPointsModel();

    model.total = response.total;
    model.minutesPlayed = response.minutes_played;
    model.yellowCards = response.yellow_cards;
    model.redCards = response.red_cards;
    model.goals = response.goals;
    model.penaltyGoals = response.penalty_goals;
    model.ownGoals = response.own_goals;
    model.assists = response.assists;
    model.cleanSheets = response.clean_sheets;
    model.shots = response.shots;
    model.shotsOn = response.shots_on;
    model.offsides = response.offsides;
    model.foulsCommitted = response.fouls_committed;
    model.penaltyCommitted = response.penalty_committed;
    model.penaltyWon = response.penalty_won;
    model.penaltyMissed = response.penalty_missed;
    model.tackles = response.tackles;
    model.concededGoals = response.conceded_goals;
    model.caughtBall = response.caught_ball;
    model.saves = response.saves;

    return model;
  };

  private remapPlayerDetailedStatsData = (response: any) => {
    const model = new PlayerStatsMatchModel();

    model.minutesPlayed = response.minutes_played;
    model.yellowCards = response.yellow_cards;
    model.redCards = response.red_cards;
    model.goals = response.goals;
    model.penaltyGoals = response.penalty_goals;
    model.penaltyCommitted = response.penalty_committed;
    model.penaltyWon = response.penalty_won;
    model.penaltyMissed = response.penalty_missed;
    model.penaltySaved = response.penalty_saved;
    model.penaltyReceived = response.penalty_received;
    model.ownGoals = response.own_goals;
    model.assists = response.assists;
    model.cleanSheets = response.clean_sheets;
    model.shots = response.shots;
    model.shotsOn = response.shots_on;
    model.shotsBlocked = response.shots_blocked;
    model.offsides = response.offsides;
    model.foulsCommitted = response.fouls_committed;
    model.foulsWon = response.fouls_won;
    model.tackles = response.tackles;
    model.tacklesBlocks = response.tackles_blocks;
    model.tacklesInterceptions = response.tackles_interceptions;
    model.concededGoals = response.conceded_goals;
    model.caughtBall = response.caught_ball;
    model.saves = response.saves;
    model.passes = response.passes;
    model.crosses = response.crosses;
    model.interceptions = response.interceptions;
    model.keyPasses = response.key_passes;
    model.passesAccuracy = response.passes_accuracy;
    model.duels = response.duels;
    model.duelsWon = response.duels_won;
    model.dribblesAttempts = response.dribbles_attempts;
    model.dribblesSuccess = response.dribbles_success;
    model.dribblesPast = response.dribbles_past;

    return model;
  };
}
